import { useQuery, useQueryClient } from '@tanstack/react-query'
import { oauth2DashboardApi } from '../api/oauth2DashboardApi'
import type { OAuth2Status } from '../types/oauth2Dashboard'

export default function useOAuthStatusQuery() {
  const queryClient = useQueryClient()
  const queryKey = ['oauth2-status']
  const query = useQuery<OAuth2Status>({
    queryKey,
    queryFn: oauth2DashboardApi.getStatus,
    refetchInterval: 300000, // 5 minutes
    refetchOnWindowFocus: true,
  })

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey })
  }

  return { ...query, invalidate }
}
